module.exports = __webpack_public_path__ + "static/media/prev-colored.331dddd4.svg";